import { PublicOccurrence } from '@cademy-package/sdk-component-types';

export const isPubliclyVisibleOccurrence = (occurrence: PublicOccurrence): boolean => {
    return occurrence.visibility === 'public';
};
